import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UseDataProps } from './types';
import { useStore } from '30.quickConnect.Stores';

export const useData = (): UseDataProps => {
  const { t } = useTranslation('inboxes');

  // On récupère le store
  const {
    InboxesStore: {
      PreFilledStore,
      MyOwnTransfersStore,
      TasksStore,
      OthersStore,
      prefilledItemsCount,
      myOwnTransfersCount,
      tasksItemsCount,
      othersItemsCount,
      totalItemsCount,
      hasMoreItems,
      loadMoreItems,
    },
  } = useStore();
  const prefilledItemsTitle = useMemo((): string => {
    const startTitle = t('qcapp_inbox_item_prefilled_form_node_name');
    return prefilledItemsCount > 0 ? `${startTitle} (${prefilledItemsCount})` : startTitle;
  }, [prefilledItemsCount, t]);

  const myOwnTransfersTitle = useMemo((): string => {
    const startTitle = t('qcapp_inbox_item_transferred_form_node_name');
    return myOwnTransfersCount > 0 ? `${startTitle} (${myOwnTransfersCount})` : startTitle;
  }, [myOwnTransfersCount, t]);

  const tasksItemsTitle = useMemo((): string => {
    const startTitle = t('qcapp_inbox_item_todolist_node_name');
    return tasksItemsCount > 0 ? `${startTitle} (${tasksItemsCount})` : startTitle;
  }, [tasksItemsCount, t]);

  const othersItemsTitle = useMemo((): string => {
    const startTitle = t('qcapp_inbox_item_category_not_found');
    return othersItemsCount > 0 ? `${startTitle} (${othersItemsCount})` : startTitle;
  }, [othersItemsCount, t]);

  const itemsShown = useMemo(
    () => prefilledItemsCount + myOwnTransfersCount + tasksItemsCount + othersItemsCount,
    [prefilledItemsCount, myOwnTransfersCount, tasksItemsCount, othersItemsCount],
  );

  return {
    PreFilledStore,
    MyOwnTransfersStore,
    TasksStore,
    OthersStore,
    prefilledItemsTitle,
    myOwnTransfersTitle,
    tasksItemsTitle,
    othersItemsTitle,
    t,
    itemsShown,
    totalItemsCount,
    hasMoreItems,
    loadMoreItems,
  };
};
